import { Roles } from "./roles.enum";
import { Permissions } from "./permissions.enum";

export const PermissionRolesMap = {
  [Permissions.LIST_STUDIES]: [Roles.Admin, Roles.StudyManager],
  [Permissions.ADD_STUDY]: [Roles.Admin],
  [Permissions.VIEW_EDIT_STUDY]: [Roles.Admin],
  [Permissions.DELETE_STUDY]: [Roles.Admin],
  [Permissions.LIST_SITES]: [Roles.Admin],
  [Permissions.ADD_SITE]: [Roles.Admin],
  [Permissions.EDIT_SITE]: [Roles.Admin],
  [Permissions.DELETE_SITE]: [Roles.Admin],
  [Permissions.ADD_CLINICAL_DEVICE]: [Roles.Admin],
  [Permissions.REMOVE_CLINICAL_DEVICE]: [Roles.Admin],
  [Permissions.REMOVE_CLINICAL_DEVICES]: [Roles.Admin],
  [Permissions.LIST_PARTICIPANTS]: [Roles.Admin, Roles.StudyManager],
  [Permissions.REGISTER_PARTICIPANT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.EDIT_PARTICIPANT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.LIST_PARTICIPANT_SESSIONS]: [Roles.Admin, Roles.StudyManager],
  [Permissions.WITHDRAW_PARTICIPANT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.COMPLETE_PARTICIPANT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.LIST_ADVERSE_EVENTS]: [Roles.Admin, Roles.StudyManager],
  [Permissions.ADD_ADVERSE_EVENT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.EDIT_ADVERSE_EVENT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.DELETE_ADVERSE_EVENT]: [Roles.Admin, Roles.StudyManager],
  [Permissions.LIST_SESSIONS]: [Roles.Admin, Roles.StudyManager],
  [Permissions.CALENDAR]: [Roles.Admin, Roles.StudyManager],
  [Permissions.SCHEDULE_SESSION]: [Roles.Admin, Roles.StudyManager],
  [Permissions.RESCHEDULE_SESSION]: [Roles.Admin, Roles.StudyManager],
  [Permissions.CANCEL_SESSION]: [Roles.Admin, Roles.StudyManager],
  [Permissions.UPDATE_SESSION_DATA]: [Roles.Admin, Roles.StudyManager],
  [Permissions.COMPLETE_SESSION]: [Roles.Admin, Roles.StudyManager],
  [Permissions.VIEW_ADMIN_DASHBOARD]: [Roles.Admin],
    [Permissions.VIEW_CLINICIAN_OPTIONS]: [Roles.StudyManager, Roles.Admin],
    [Permissions.SEND_WHATSAPP_MESSAGE]: [Roles.Admin],
  [Permissions.VIEW_CONTRACTS]: [Roles.Admin, Roles.AdminContract],
  [Permissions.CREATE_CONTRACT]: [Roles.Admin],
  [Permissions.EDIT_CONTRACT_CODE]: [Roles.Admin],
  [Permissions.MANAGE_CONTRACT_ADMINS]: [Roles.Admin],
  [Permissions.VIEW_CONTRACT_HISTORY]: [Roles.Admin],
  [Permissions.CHANGE_CONTRACT_STATE]: [Roles.Admin],
  [Permissions.DELETE_CONTRACT]: [Roles.Admin],
  [Permissions.VIEW_ORGANISATIONS]: [Roles.Admin, Roles.AdminOrg],
  [Permissions.CREATE_ORGANISATION]: [Roles.Admin],
  [Permissions.EDIT_ORGANISATION_CODE]: [Roles.Admin],
  [Permissions.MANAGE_ORGANISATION_ADMINS]: [Roles.Admin],
  [Permissions.VIEW_ORGANISATION_HISTORY]: [Roles.Admin],
  [Permissions.CHANGE_ORGANISATION_STATE]: [Roles.Admin],
  [Permissions.DELETE_ORGANISATION]: [Roles.Admin],
  [Permissions.MANAGE_ORGANISATION_CONTRACTS]: [Roles.Admin],
  [Permissions.MANAGE_ORGANISATION_CARE_PROGRAMS]: [Roles.Admin, Roles.AdminOrg],
  [Permissions.MANAGE_ORGANISATION_SERVICES]: [Roles.Admin, Roles.AdminOrg],
  [Permissions.VIEW_CONTRACT_ORGANISATIONS]: [Roles.Admin, Roles.AdminContract],
  [Permissions.MANAGE_CONTRACT_ORGANISATIONS]: [Roles.Admin, Roles.AdminContract],
};
